import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { Promises } from '../components/Promises';
import { Services } from '../components/Services';
import { Gallery } from '../components/Gallery';
import { EstimateCTA } from '../components/EstimateCTA';
import { SiteFooter } from '../components/SiteFooter';
import { CallBar } from '../components/CallBar';
export function Home() {
  return <div className="w-full bg-white" data-id="element-115" data-mp="1zjii0axcso0x">
      <SiteHeader data-id="element-116" data-mp="24h0mnp4c8h34" />
      <main data-id="element-117" data-mp="24g8teky7qvg0">
        <Hero data-id="element-118" data-mp="24i3dxy5koljk" />
        <Promises data-id="element-119" data-mp="24hk8hgx3zpmf" />
        <Services data-id="element-120" data-mp="24j4s4bhvxo5i" />
        <Gallery data-id="element-121" data-mp="29g4zqquduyyq" />
        <EstimateCTA data-id="element-122" data-mp="29flpzxevzgvs" />
      </main>
      <SiteFooter data-id="element-123" data-mp="29ek38void5y8" />
      <div className="h-16 sm:hidden" aria-hidden="true" data-id="element-124" data-mp="29i7yq0dik2fl" />
      <CallBar data-id="element-125" data-mp="2diruazifuxzm" />
    </div>;
}